import config from "../../common/config";

export function initClient(currentUser) {
  function integrateProd() {
    let _paq = (window._paq = window._paq || []);
    _paq.push(["setUserId", currentUser.email]);
    _paq.push(["setCustomDimension", 1, currentUser.jobProfile]);
    _paq.push(["setCustomDimension", 2, currentUser.departmentCode]);
    _paq.push(["setCustomDimension", 3, currentUser.homeCountry]);
    _paq.push(["trackPageView"]);
    _paq.push(["enableLinkTracking"]);
    (function () {
      const url = "https://thoughtworks.innocraft.cloud/";
      _paq.push(["setTrackerUrl", url + "matomo.php"]);
      _paq.push(["setSiteId", "76"]);
      const d = document,
        g = d.createElement("script"),
        s = d.getElementsByTagName("script")[0];
      g.async = true;
      g.src = url + "matomo.js";
      s.parentNode.insertBefore(g, s);
    })();
  }

  function integrateStaging() {
    let _paq = (window._paq = window._paq || []);
    _paq.push(["setUserId", currentUser.email]);
    _paq.push(["setCustomDimension", 1, currentUser.jobProfile]);
    _paq.push(["setCustomDimension", 2, currentUser.departmentCode]);
    _paq.push(["setCustomDimension", 3, currentUser.homeCountry]);
    _paq.push(["trackPageView"]);
    _paq.push(["enableLinkTracking"]);
    (function () {
      const u = "https://thoughtworks.innocraft.cloud/";
      _paq.push(["setTrackerUrl", u + "piwik.php"]);
      _paq.push(["setSiteId", "81"]);
      const d = document,
        g = d.createElement("script"),
        s = d.getElementsByTagName("script")[0];
      g.async = true;
      g.src = u + "piwik.js";
      s.parentNode.insertBefore(g, s);
    })();
  }

  if (trackProd()) {
    integrateProd();
  } else if (trackStaging()) {
    integrateStaging();
  }
}

const EventCategory = {
  Menu: "Menu",
  Tab: "tab",
  Application: "Application",
  Review: "Review",
  ReviewTask: "Review Task",
  User: "User",
  Table: "Table",
  AppInfo: "App Info",
  Other: "Other",
  UserGroup: "User Group",
  UserGroupDetails: "User Group Details",
  InformationAssets: "Information Assets",
};

export const MenuAction = {
  Applications: "Clicked on Applications",
  Users: "Clicked on Users",
  UserGroups: "Clicked on User Groups",
  InformationAssets: "Clicked on Information Assets",
  Policies: "Clicked on Policies",
  UserGuide: "Clicked on User Guide",
};

export const ApplicationAction = {
  GoAccessTypes: "View Access Types",
  RequestUserAccess: "Request User Access Data",
  SwitchToggle: "Switch Toggle",
  AppInfoAction: "App Info Action",
  ClickMyTasksCount: "Clicked on my tasks count",
};

export const ReviewAction = {
  PreviewBeforeStartReview: "Preview Before Start Review",
  StartReview: "Start Review",
  CloseReview: "Close Review",
  CancelReview: "Cancel Review",
  DownloadReport: "Download Review Report",
  SendReminder: "Send Reminder For In Progress Review",
  OpenUpload: "Open Upload Modal",
  CloseUpload: "Close Upload Modal",
  UploadedFile: "Uploaded File",
  SubmitFiles: "Submit Files",
  DownloadErrorsOnSubmittingUploadedFiles: "Download Error File On Submitting Uploaded Files",
  OpenedDownloadModal: "Opened Download Modal",
  ClosedDownloadModal: "Closed Download Modal",
  DownloadReviewFiles: "Download review files",
  ViewComment: "View Comment",
  OpenedFileVerificationModal: "Opened File Verification Modal",
  SubmittedFileVerification: "Submitted File Verification",
  OpenNewReviewModal: "Opened New Review Round Modal",
  NewReviewStarted: "New Review Round Started",
};

export const ReviewTaskAction = {
  ViewReviewTasks: "View Review Tasks",
  SubmitReviewTask: "Submit Review Tasks",
  ReassignTask: "Reassign Review Task",
};

export const UserAction = {
  UserAccessHistory: "View User Access History",
  UserDetails: "Go To User Details Page",
  TabChange: (tabName) => {
    return `Clicked on ${tabName}`;
  },
  BackToUserList: "Back To User List",
  UserGroupDetails: "Go To Business Team",
};

export const UserGroupAction = {
  TabChange: "Tab Change",
  UserGroupClick: (userGroupRepresentationName) => {
    return `Clicked on ${userGroupRepresentationName}`;
  },
};

export const InformationAssetsAction = {
  InformationAssets: "View Information Assets",
  TabChange: (tabName) => {
    return `Clicked on ${tabName}`;
  },
  AccessDetails: (value) => `Go to ${value} Access Details`,
  BackToInformationAssets: "Back to information assets",
  Resource: (value) => `Go to ${value}`,
  GroupDetails: (groupName) => {
    return `Go to ${groupName} Details`;
  },
  LinksClickedInAccessDetailsTabs: (linkText, groupName) => {
    return `Navigated to ${linkText} that are associated to ${groupName} from Access Details Tab`;
  },
  BackToAccessDetails: "Back to Access Details",
};

export const UserGroupDetailsAction = {
  CopyAllEmails: {
    users: (userGroupName, userRole) => {
      return `Copy ${userGroupName} ${userRole} emails`;
    },
  },
  BackToUserGroupList: (userGroupTypeName) => {
    return `Back to ${userGroupTypeName} list`;
  },
  TabChange: (userGroupName) => {
    return `${userGroupName} Details page tab change`;
  },
  BackToUserGroupDetails: (title) => {
    return `Back to ${title} page`;
  },
  AddMembershipCondition: "Add member condition",
  SearchMembersByName: "Search members by name",
  SearchMembersByCondition: "Search members by key condition",
  ViewKeyConditionMembers: "View key condition members",
  EditKeyCondition: "Edit key condition",
  DeleteKeyCondition: "Delete key condition",
  EditIndividualInclusionMemberDetails: "Edit individual inclusion members",
  DeleteIndividualInclusionMemberDetails: "Delete individual inclusion members",
  PreviewAndAddSpecialConditions: "Preview and add special conditions",
  PreviewAndAddConditions: "Preview and add conditions",
  PreviewAndUpdateSpecialConditions: "Preview and update special conditions",
  PreviewAndUpdateConditions: "Preview and update conditions",
  AddSpecialConditionConfirmation: "Add special condition confirmation",
  AddConditionConfirmation: "Add condition confirmation",
  UpdateSpecialConditionConfirmation: "Update special condition confirmation",
  UpdateConditionConfirmation: "Update condition confirmation",
  DeleteSpecialConditionConfirmation: "Delete special condition confirmation",
  DeleteConditionConfirmation: "Delete condition confirmation",
};

export const OtherAction = {
  Feedback: "Feedback",
  Help: "Help",
  Logout: "Logout",
};

export const TableAction = {
  Search: "Search",
  Filter: "Filter",
  SelectColumn: "Select Columns",
};

export const AppInfoAction = {
  CopyGAAEmails: "Copy GAA Emails",
  CopyAOEmails: "Copy AO Emails",
};

function trackProd() {
  return config.isProd();
}

function trackStaging() {
  return config.isStaging();
}

export function sendMenuEvent(eventAction, eventName) {
  window?._paq?.push(["trackEvent", EventCategory.Menu, eventAction, eventName]);
}

export function sendSwitchTabEvent(eventAction, eventName) {
  window?._paq?.push(["trackEvent", EventCategory.Tab, eventAction, eventName]);
}

export function sendApplicationEvent(eventAction, eventName) {
  window?._paq?.push(["trackEvent", EventCategory.Application, eventAction, eventName]);
}

export function sendReviewEvent(eventAction, eventName) {
  window?._paq?.push(["trackEvent", EventCategory.Review, eventAction, eventName]);
}

export function sendReviewTaskEvent(eventAction, eventName) {
  window?._paq?.push(["trackEvent", EventCategory.ReviewTask, eventAction, eventName]);
}

export function sendUserEvent(eventAction, eventName) {
  window?._paq?.push(["trackEvent", EventCategory.User, eventAction, eventName]);
}

export function sendOtherEvent(eventAction, eventName) {
  window?._paq?.push(["trackEvent", EventCategory.Other, eventAction, eventName]);
}

export function sendTableEvent(eventAction, eventName) {
  window?._paq?.push(["trackEvent", EventCategory.Table, eventAction, eventName]);
}

export function sendAppInfoEvent(eventAction, eventName) {
  window?._paq?.push(["trackEvent", EventCategory.AppInfo, eventAction, eventName]);
}

export function sendUserGroupEvent(eventAction, eventName) {
  window?._paq?.push(["trackEvent", EventCategory.UserGroup, eventAction, eventName]);
}

export function sendUserGroupDetailsEvent(eventAction, eventName) {
  window?._paq?.push(["trackEvent", EventCategory.UserGroupDetails, eventAction, eventName]);
}

export function trackPage(pageName) {
  window?._paq?.push(["setDocumentTitle", pageName], ["setCustomUrl", window.location.href], ["trackPageView"]);
}

export function sendInformationAssetsEvent(eventAction, eventName) {
  window?._paq?.push(["trackEvent", EventCategory.InformationAssets, eventAction, eventName]);
}
